(()=>{
  const productPath=(href)=>{
    try{return new URL(href,window.location.origin).pathname.replace(/\/$/,'')}catch{return href||''}
  };

  const initRoot=async(root)=>{
    if(!root||root.dataset.akFullLineupReady==='true')return;
    root.dataset.akFullLineupReady='true';

    const home=root.closest('.ak-home')||document;
    const productStrip=root.querySelector('.ak-hero-products');
    const detailWrap=root.querySelector('.ak-hero-detail-wrap');
    if(!productStrip||!detailWrap)return;

    const tapHint=detailWrap.querySelector('.ak-hero-tap-hint');
    const existing=new Set(
      [...detailWrap.querySelectorAll('[data-ak-hero-detail] a[href*="/products/"]')]
        .map(a=>productPath(a.getAttribute('href')))
        .filter(Boolean)
    );

    const sources=[];
    [...home.querySelectorAll('#ak-jerky-showcase [data-ak-slide]')].forEach(slide=>{
      const link=slide.querySelector('.ak-switcher-media[href*="/products/"],.ak-home-product-actions a[href*="/products/"]');
      if(!link)return;
      const url=productPath(link.getAttribute('href'));
      if(!url||existing.has(url)||sources.some(item=>item.url===url))return;
      sources.push({
        url,
        title:slide.querySelector('h3')?.textContent.trim()||'Jerky',
        price:slide.querySelector('.ak-switcher-price')?.textContent.trim()||'',
        description:slide.querySelector('.ak-switcher-description')?.textContent.trim()||'',
        type:slide.querySelector('.ak-switcher-type')?.textContent.trim()||'JERKY',
        fallbackImage:slide.querySelector('.ak-switcher-media img')?.currentSrc||slide.querySelector('.ak-switcher-media img')?.src||''
      });
    });

    const tilts=['-5deg','2deg','-2deg','4deg','-3deg','1deg'];
    await Promise.all(sources.map(async(info,index)=>{
      let bagSrc='';
      try{
        const response=await fetch(`${info.url}.js`,{headers:{Accept:'application/json'}});
        if(response.ok){
          const product=await response.json();
          let candidate=product.featured_image||(Array.isArray(product.images)?product.images[0]:'');
          if(typeof candidate==='object')candidate=candidate.src||candidate.url||'';
          bagSrc=candidate||'';
        }
      }catch{}
      if(!bagSrc)bagSrc=info.fallbackImage;

      const button=document.createElement('a');
      button.className='ak-hero-product';
      button.href=info.url;
      button.dataset.akHeroProduct='';
      button.setAttribute('aria-current','false');
      button.setAttribute('aria-label',`View ${info.title} product details`);
      button.style.setProperty('--hero-tilt',tilts[(productStrip.querySelectorAll('[data-ak-hero-product]').length+index)%tilts.length]);
      if(bagSrc){
        const img=document.createElement('img');
        img.src=bagSrc;
        img.alt=info.title;
        img.loading='lazy';
        img.decoding='async';
        button.appendChild(img);
      }
      productStrip.appendChild(button);

      const article=document.createElement('article');
      article.className='ak-hero-detail';
      article.dataset.akHeroDetail='';
      article.setAttribute('aria-hidden','true');

      const type=document.createElement('p');
      type.className='ak-hero-detail-type';
      type.textContent=info.type;
      article.appendChild(type);

      const title=document.createElement('h2');
      title.textContent=info.title;
      article.appendChild(title);

      if(info.price){
        const price=document.createElement('p');
        price.className='ak-hero-detail-price';
        price.textContent=info.price;
        article.appendChild(price);
      }

      const copy=document.createElement('p');
      copy.className='ak-hero-detail-copy';
      copy.textContent=info.description||'Bold, savory jerky made for serious snacking.';
      article.appendChild(copy);

      const actions=document.createElement('div');
      actions.className='ak-home-product-actions';
      const buy=document.createElement('a');
      buy.className='ak-btn ak-btn--red';
      buy.href=info.url;
      buy.textContent='BUY NOW';
      const detailsLink=document.createElement('a');
      detailsLink.className='ak-btn ak-btn--ghost ak-home-details';
      detailsLink.href=info.url;
      detailsLink.textContent='VIEW PRODUCT DETAILS';
      actions.append(buy,detailsLink);
      article.appendChild(actions);

      if(tapHint&&tapHint.parentNode===detailWrap){
        detailWrap.insertBefore(article,tapHint);
      }else{
        detailWrap.appendChild(article);
      }
      existing.add(info.url);
    }));

    const buttons=[...root.querySelectorAll('[data-ak-hero-product]')];
    const details=[...root.querySelectorAll('[data-ak-hero-detail]')];
    if(!buttons.length||!details.length)return;

    const oldBurst=root.querySelector('.ak-jerky-burst-stage');
    if(oldBurst)oldBurst.remove();
    const burstStage=document.createElement('div');
    burstStage.className='ak-jerky-burst-stage';
    burstStage.setAttribute('aria-hidden','true');
    root.prepend(burstStage);
    const bursts=buttons.map((button,i)=>{
      const burst=document.createElement('div');
      burst.className='ak-jerky-burst';
      burst.dataset.burstIndex=i;
      burstStage.appendChild(burst);
      return burst;
    });

    const fallbackImage=(i)=>buttons[i]?.querySelector('img')?.currentSrc||buttons[i]?.querySelector('img')?.src||'';
    const productUrl=(i)=>details[i]?.querySelector('a[href*="/products/"]')?.getAttribute('href')||'';
    const normalizeImage=(image,fallback='')=>{
      if(typeof image==='string')return image;
      if(image&&typeof image==='object')return image.src||image.url||fallback;
      return fallback;
    };
    const buildBurst=(burst,src)=>{
      if(!src)return;
      burst.innerHTML='';
      for(let n=0;n<5;n++){
        const img=document.createElement('img');
        img.src=src;
        img.alt='';
        img.loading=n===0?'eager':'lazy';
        img.decoding='async';
        img.style.setProperty('--piece',n);
        burst.appendChild(img);
      }
    };

    bursts.forEach((burst,i)=>{
      const fallback=fallbackImage(i);
      if(fallback)buildBurst(burst,fallback);
      const url=productUrl(i);
      if(!url)return;
      const clean=productPath(url);
      fetch(`${clean}.js`,{headers:{Accept:'application/json'}})
        .then(r=>r.ok?r.json():Promise.reject())
        .then(product=>{
          const images=(Array.isArray(product.images)?product.images:[])
            .map(image=>normalizeImage(image,''))
            .filter(Boolean);
          const title=String(product.title||details[i]?.querySelector('h2')?.textContent||'').toLowerCase();
          let src='';
          if(title.includes('carolina reaper')&&images.length>1){
            src=images[images.length-1]||images[2]||images[1]||images[0]||fallback;
          }else{
            src=images[1]||images[0]||fallback;
          }
          if(src)buildBurst(burst,src);
        })
        .catch(()=>{});
    });

    const centerBag=(i)=>{
      if(!productStrip||!buttons[i])return;
      const button=buttons[i];
      const target=button.offsetLeft-(productStrip.clientWidth-button.offsetWidth)/2;
      productStrip.scrollTo({left:Math.max(0,target),behavior:'smooth'});
    };

    const initialMarked=Math.max(0,buttons.findIndex(b=>b.classList.contains('is-active')));
    let activeIndex=matchMedia('(min-width:901px)').matches&&buttons.length>=5
      ? Math.min(2,buttons.length-1)
      : initialMarked;
    const activate=(i)=>{
      activeIndex=((i%buttons.length)+buttons.length)%buttons.length;
      buttons.forEach((b,n)=>{
        const on=n===activeIndex;
        b.classList.toggle('is-active',on);
        b.setAttribute('aria-current',on?'true':'false');
      });
      details.forEach((d,n)=>{
        const on=n===activeIndex;
        d.classList.toggle('is-active',on);
        d.setAttribute('aria-hidden',on?'false':'true');
      });
      bursts.forEach((b,n)=>b.classList.toggle('is-active',n===activeIndex));
      root.style.setProperty('--active-index',activeIndex);
      centerBag(activeIndex);
    };

    root.querySelectorAll('.ak-hero-strip-arrow').forEach(arrow=>arrow.remove());
    const makeStripArrow=(direction,label)=>{
      const arrow=document.createElement('button');
      arrow.type='button';
      arrow.className=`ak-hero-strip-arrow ak-hero-strip-arrow--${direction}`;
      arrow.setAttribute('aria-label',label);
      arrow.innerHTML='<span aria-hidden="true"></span>';
      arrow.addEventListener('click',e=>{
        e.preventDefault();
        e.stopPropagation();
        activate(activeIndex+(direction==='next'?1:-1));
      });
      root.appendChild(arrow);
    };
    makeStripArrow('prev','Previous jerky');
    makeStripArrow('next','Next jerky');

    const positionStripArrows=()=>{
      if(!productStrip)return;
      const top=productStrip.offsetTop+(productStrip.offsetHeight*.53);
      const left=productStrip.offsetLeft;
      const right=Math.max(0,root.clientWidth-(productStrip.offsetLeft+productStrip.offsetWidth));
      root.style.setProperty('--ak-hero-strip-arrow-top',`${Math.round(top)}px`);
      root.style.setProperty('--ak-hero-strip-arrow-left',`${Math.round(left)}px`);
      root.style.setProperty('--ak-hero-strip-arrow-right',`${Math.round(right)}px`);
    };
    positionStripArrows();
    window.addEventListener('resize',positionStripArrows,{passive:true});
    if('ResizeObserver' in window)new ResizeObserver(positionStripArrows).observe(productStrip);

    buttons.forEach((button,i)=>{
      button.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches)activate(i)});
      button.addEventListener('focus',()=>activate(i));
    });

    activate(activeIndex);
    if(tapHint&&tapHint.parentNode===detailWrap)tapHint.remove();
    window.dispatchEvent(new Event('pageshow'));
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-hero-focus]').forEach(initRoot);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();